
import {
  LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS, LOAD_SENTIMENT_BREAKDOWN_SUCCESS,
  SEARCH_CHANGE
} from "./full-report-primary-or-sentiment-action-types";
import deepCopy from "../../utilities/deepCopy";
import {searchChangeInTerms} from "../../utilities/searchChangeInTerms";

const initialState = {
  primaryEmotionsBreakdown: [],
  primaryEmotionsBreakdownProcessed: [],
  sentimentBreakdown: [],
  sentimentBreakdownProcessed: [],
  primarySearchValue: "",
  sentimentSearchValue: ""
};

export default ( state = initialState, action ) => {

  const { primaryEmotionsBreakdown, sentimentBreakdown, searchValue, primary } = action;

  switch(action.type) {

    case SEARCH_CHANGE:
      const data = primary ? state.primaryEmotionsBreakdown : state.sentimentBreakdown;
      const result = searchChangeInTerms({
        data: deepCopy(data),
        searchValue
      });
      return primary ? {
        ...state,
        primaryEmotionsBreakdownProcessed: result,
        primarySearchValue: searchValue
      }
      :
        {
          ...state,
          sentimentBreakdownProcessed: result,
          sentimentSearchValue: searchValue
        };

    case LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS:

      return {
        ...state,
        primaryEmotionsBreakdown: primaryEmotionsBreakdown,
        primaryEmotionsBreakdownProcessed: primaryEmotionsBreakdown
      };

    case LOAD_SENTIMENT_BREAKDOWN_SUCCESS:

      return {
        ...state,
        sentimentBreakdown: sentimentBreakdown,
        sentimentBreakdownProcessed: sentimentBreakdown
      };



    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/full-report-primary-or-sentiment/full-report-primary-or-sentiment-reducer.js